const BRIGHTNESS_OFFSET = 60;

export const getColorBrightness = (color: string): number | null => {
  try {
    if (color.startsWith('#')) {
      let hex = color.slice(1);
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      if (hex.length !== 6) return null;
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      if ([r, g, b].some(Number.isNaN)) return null;

      return (r + g + b) / 3;
    }

    const match = color.match(/rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/i);
    if (match) {
      return (parseInt(match[1], 10) + parseInt(match[2], 10) + parseInt(match[3], 10)) / 3;
    }

    return null;
  } catch {
    return null;
  }
};

export const allowedAsPrimaryColor = (color: string, isDarkMode = false): boolean => {
  try {
    const brightness = getColorBrightness(color);
    if (brightness === null) return true;

    return isDarkMode ? brightness > BRIGHTNESS_OFFSET : brightness < 255 - BRIGHTNESS_OFFSET;
  } catch {
    return true;
  }
};

export const clampPrimaryColor = (color: string | null | undefined, isDarkMode = false): string | null | undefined => {
  try {
    if (!color) return color;

    return allowedAsPrimaryColor(color, isDarkMode) ? color : '#000000';
  } catch {
    return color;
  }
};
